import { createFileRoute } from '@tanstack/react-router'
import CampaignDetail from '@/components/campaign-detail-route/campaign-detail'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'

export const Route = createFileRoute('/_auth/campaign/$campaignId/')({
  beforeLoad: ({ location }) =>
    navigateGuard(location, [
      UserRole.ADMINISTRATOR,
      UserRole.SUPERVISOR,
      UserRole.TEAM_LEADER,
    ]),
  component: CampaignDetailWrapper,
})

function CampaignDetailWrapper() {
  const { campaignId } = Route.useParams()

  return <CampaignDetail campaignId={campaignId} />
}
